import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { StyledDiv, phoneOnly } from '../../../../common/ConstantsStyles';
import { PSXIcon } from '../../../../common/PSXIcon';
import { StyledCloseButton } from './SharedAccessErrorModal.styled';

const SharedAccessErrorModal = () => {
  const mobileScreen = useMediaQuery(phoneOnly);
  const [isOpen, setIsOpen] = useState(true);

  const alignVal = mobileScreen ? 'left' : 'center';
  const { t } = useTranslation();

  function onClick(url, phone) {
    adobeLinkTrackEvent({
      name: `call ${phone}`,
      location: 'body: error modal',
      type: 'phone',
      destinationUrl: url,
    });
  }

  const onClose = () => {
    setIsOpen(false);
    window.location.href = window.location.origin;
  };

  return (
    <ModalDialog
      closeOnClickOutside={false}
      closeOnEscPress={false}
      css={{
        '&.abyss-modal-base-body': {
          borderRadius: '8px',
          maxHeight: '100%',
        },
        'abyss-modal-header-container': {
          display: 'none',
        },
      }}
      data-auto-testid="shared-access-error-modal"
      data-testid="shared-access-error-modal"
      isOpen={isOpen}
      onClose={onClose}
      size={mobileScreen ? 320 : 624}
      /* Title is added to prevent JS error as the component required title prop, title is hidden adding css rules for abyss-modal-header-container */
      title={t('SHARED_ACCESS_ERROR_MODAL.HEADING')}
    >
      <StyledDiv css={{ padding: '16px 16px 12px' }}>
        <Layout.Stack alignLayout="center" space={0}>
          <IconBrand brand="uhc" icon="alert" size={84} variant="twotone" />
        </Layout.Stack>
        <Layout.Stack alignItems={alignVal} alignLayout={alignVal} space={10}>
          <Heading
            color="$core.color.neutral.90"
            data-auto-testid="shared-access-error-modal-heading"
            data-testid="shared-access-error-modal-heading"
            level={2}
            size="xs"
          >
            {t('SHARED_ACCESS_ERROR_MODAL.HEADING')}
          </Heading>
          <Text
            color="$core.color.neutral.90"
            data-auto-testid="shared-access-error-modal-message"
            data-testid="shared-access-error-modal-message"
            fontSize="md"
          >
            {t('SHARED_ACCESS_ERROR_MODAL.MESSAGE')}
          </Text>
        </Layout.Stack>
      </StyledDiv>
      <StyledDiv
        css={{
          padding: '0 16px 16px',
          '@media (max-width: 464px)': {
            padding: '0 16px 12px',
          },
        }}
      >
        <Layout.Stack alignLayout={alignVal} space={0}>
          <StyledCloseButton
            data-auto-testid="shared-access-error-modal-close-button"
            data-testid="shared-access-error-modal-close-button"
            onClick={onClose}
            size="$md"
          >
            {t('SHARED_ACCESS_ERROR_MODAL.CLOSE')}
          </StyledCloseButton>
        </Layout.Stack>
      </StyledDiv>
      <Divider height="1px" margin={0} />
      <StyledDiv
        css={{
          padding: '16px 24px',

          '@media (max-width: 464px)': {
            padding: '12px 16px 16px',
          },
        }}
      >
        <Layout.Stack alignItems="left" space={mobileScreen ? 10 : 16}>
          <Text
            color="$core.color.brand.100"
            data-auto-testid="shared-access-error-modal-more-help"
            data-testid="shared-access-error-modal-more-help"
            fontSize="md"
            fontWeight="bold"
          >
            {t('SHARED_ACCESS_ERROR_MODAL.MORE_HELP')}
          </Text>
          <Link
            data-auto-testid="shared-access-error-modal-call-us"
            data-testid="shared-access-error-modal-call-us"
            href={`tel:18778444999`}
            onClick={() => onClick(`tel: 18778444999`, '18778444999')}
          >
            <PSXIcon icon="call_us" size={20} />
            {t('SHARED_ACCESS_ERROR_MODAL.CALL_US')}
          </Link>
        </Layout.Stack>
      </StyledDiv>
    </ModalDialog>
  );
};
export default SharedAccessErrorModal;
